import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable, of } from "rxjs";
import { filter, switchMap, tap } from "rxjs/operators";
import { Roles } from "app/models/profile.models";
import { AuthService } from "./auth.service";
	
@Injectable()
export class AuthGuardAdminRole {

	constructor(
		private authService: AuthService,
		private router: Router
	) {
	}

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot,
	): Observable<boolean | UrlTree> {
		console.log("AuthGuardAdminRole", this.authService.isInRole(Roles.ADMIN));
		if (!this.authService.isInRole(Roles.ADMIN)) return of(this.router.parseUrl("/unautorized-page"));

		return this.authService.isDoneLoading$.pipe(
					filter(isDone => isDone),
					switchMap(_ => this.authService.isAuthenticated$),
					tap(isAuthenticated => isAuthenticated &&  this.authService.isInRole(Roles.ADMIN) ),
				);

		// if (this.authService.hasValidToken) {
		// 	console.log("!this.authService.isInRole(Roles.ADMIN): " + !this.authService.isInRole(Roles.ADMIN));
			
		// 	if (!this.authService.isInRole(Roles.ADMIN)) {
		// 		return of(this.router.parseUrl("/unautorized-page"));
		// 	}
		// 	return of(this.router.parseUrl(state.url));
		// }
		// return of(false);
	}
}